import { createContext, Dispatch, SetStateAction } from "react";
import { DrawerSelectOptionType } from "./drawer-select.types";

export type DrawerSelectVariant = "inline" | "modal";

export type DrawerSelectContextType = {
  /** Valor exibido no trigger (aplicado ou seleção atual quando uncontrolled) */
  value?: DrawerSelectOptionType[];
  /** Indica se o drawer está aberto */
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  /** Label do select (ex.: título no modal) */
  label?: string;
  /** Quando definido, usado para filtrar as opções no lugar de queryValue */
  query?: string;
  handleQueryValueChange: (query: string) => void;
  /** Opções registradas pelos DrawerSelectOption */
  options: DrawerSelectOptionType[];
  variant?: DrawerSelectVariant;
  /** Permite seleção múltipla quando true; seleção única quando false */
  multiple?: boolean;
  /** Número máximo de opções selecionáveis (apenas quando multiple=true). Se undefined, não há limite. */
  maxOptions?: number;
  handleApply: () => void;
  handleClear: () => void;
  handleClearValue: () => void;
  /** Seleciona uma única opção e aplica imediatamente (usado quando multiple=false e variant=inline) */
  selectSingleOption: (option: DrawerSelectOptionType) => void;
  /** Apenas define a opção selecionada no estado, sem aplicar nem fechar (usado quando multiple=false e variant=modal) */
  selectOnlyOption: (option: DrawerSelectOptionType) => void;
  pushOption: (option: DrawerSelectOptionType) => void;
  removeOption: (option: DrawerSelectOptionType) => void;
  toggleOption: (option: DrawerSelectOptionType) => void;
  isOptionSelected: (option: DrawerSelectOptionType) => boolean;
  /** Variaveis de customização do modal */
  applyButtonText?: string;
  clearButtonText?: string;
  modalTitle?: string;
  /** Altura máxima do corpo do modal (ex: "70vh", "400px"). Quando definido, o conteúdo do modal rola ao exceder. */
  modalMaxHeight?: string;
  /** Quando há busca ativa, número máximo de opções exibidas. Se não definido, todas as opções que passam no filtro são exibidas. */
  searchLimit?: number;
  maxOptionsReached: boolean;
  isLoading?: boolean;
};

export const DRAWER_SELECT_DEFAULT_CONTEXT: DrawerSelectContextType = {
  toggleOption: () => {},
  selectSingleOption: () => {},
  selectOnlyOption: () => {},
  pushOption: () => {},
  removeOption: () => {},
  handleQueryValueChange: () => {},
  handleApply: () => {},
  handleClear: () => {},
  handleClearValue: () => {},
  setIsOpen: () => {},
  variant: "inline",
  multiple: false,
  isOpen: false,
  options: [],
  isOptionSelected: () => false,
  value: [],
  maxOptionsReached: false,
  isLoading: false,
};

export const DrawerSelectContext = createContext<DrawerSelectContextType>(
  DRAWER_SELECT_DEFAULT_CONTEXT,
);
